import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";

import {LoginService} from "app/login/login.service";
import {MeusLaudosPdfModel} from "./meus-laudos-pdf.model";

import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BasicValidators} from "../../shared/basic-validators";

import {ClientesLaudosPdfService} from "./clientes-laudos-pdf.service";
import {Components} from "../../shared/components/components";
import {Global} from "../../global";
import {Funcoes} from "../../funcoes";

declare let swal, $: any;

@Component({
  selector: 'app-laudos-pdf',
  templateUrl: './meus-laudos-pdf.component.html'
})
export class MeusLaudosPdfComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"status_pesquisa":"", "data_de":"", "data_ate":"", "mercadoria":"", "cliente":"", "terminal":"", "id_unidade": ""};
  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  formSolicitarFicha: FormGroup;
  solicitaFicha = {"id_ficha": null, "nome": "", "email": ""};
  processandoSolicitarFicha: boolean = false;

  laudos: MeusLaudosPdfModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listStatusFichas = [];
  listMercadorias = [];
  listClientes  = [];
  listTerminal = [];
  listUnidades = [];

  listVisibilidades: any[] = [];
  clienteSelecionado: string = null;

  constructor(
    formBuilder: FormBuilder,
    private laudosService: ClientesLaudosPdfService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    public loginService: LoginService
  ) {
    super();

    let date = new Date().toISOString();
    this.filtroPesquisa.data_de = date.substr(0, 8)+'01';
    this.filtroPesquisa.data_ate = date.substr(0, 10);

    this.formPesquisaAvancada = formBuilder.group({
      status_pesquisa: [],
      data_de: [],
      data_ate: [],
      mercadoria: [],
      cliente: [],
      terminal: [],
      id_unidade: []
    });

    this.formSolicitarFicha = formBuilder.group({
      id_ficha: ['', [
        Validators.required
      ]],
      nome: ['', [
        Validators.required
      ]],
      email: ['', [
        Validators.required,
        BasicValidators.email
      ]],
    });

  }

  ngOnInit() {
    this.laudosService.getVisibilidades().subscribe(
      json => {
        if (json && json.Success && json.Payload) {
          this.listVisibilidades = json.Payload;
        }
      },
      error => {
        console.error('Erro ao carregar visibilidades:', error);
      }
    );
    this.getPage(1);
  }

  selecionarAbaCliente(idCliente: string = null) {
    this.clienteSelecionado = idCliente;
    this.getPage(1);
  }

  formatNomeAba(nome: string): string {
    if (!nome) return '';
    return nome.length > 40 ? nome.substring(0, 40) + '...' : nome;
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if (this.clienteSelecionado) {
      filtros['id_cliente'] = 'eq:' + this.clienteSelecionado;
    }

    /*if(this.filtroPesquisa.status_pesquisa != ''){
      filtros['id_status'] = this.filtroPesquisa.status_pesquisa;
    }

    if(this.filtroPesquisa.data_de != ''){
      filtros['data'] = 'ge:'+this.filtroPesquisa.data_de;
    }

    if(this.filtroPesquisa.data_ate != ''){
      filtros['data'] = 'le:'+this.filtroPesquisa.data_ate;
    }

    if(this.filtroPesquisa.mercadoria != ''){
      filtros['id_mercadoria'] = this.filtroPesquisa.mercadoria;
    }

    if(this.filtroPesquisa.cliente != ''){
      filtros['id_cliente'] = this.filtroPesquisa.cliente;
    }

    if(this.filtroPesquisa.terminal != ''){
      filtros['id_terminal'] = this.filtroPesquisa.terminal;
    }

    if(this.filtroPesquisa.id_unidade != ''){
      filtros['id_unidade'] = this.filtroPesquisa.id_unidade;
    }*/


    this.laudosService.getPaginacao(pagina, this.itensPorPagina, ['mercadoria', 'cliente', 'unidade', 'terminal', 'status'], filtros)
      .subscribe(data => {
          this.laudos = data['Payload']['data'];
          this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;

          if (this.global.debug) {
            console.log(this.laudos);
          }
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"status_pesquisa":"", "data_de":"", "data_ate":"", "mercadoria":"", "cliente":"", "terminal":"", "id_unidade": ""};
  }

  modalSolicitaFicha(id){
    this.solicitaFicha.id_ficha = id;
    this.processandoSolicitarFicha = false;
    $('#modalSolicitarFicha').modal('show');
  }

  solicitaFichaEmail(){
    this.processandoSolicitarFicha = true;
    this.laudosService.enviaPdfEmail(this.solicitaFicha.id_ficha, this.solicitaFicha)
      .subscribe(json => {
          this.processandoSolicitarFicha = false;
          $('#modalSolicitarFicha').modal('hide');
        },
        error => {
          this.processandoSolicitarFicha = false;
          this.func.showErro(error.json());
        });
  }

  baixarPdf(id) {
    this.carregandoTabela = true;
    this.laudosService.baixarZipPdf(id)
      .subscribe(
        json => {
          this.carregandoTabela = false;
          if (json && json.Success && json.Payload) {
            window.open(this.laudosService.dominio + json.Payload, '_blank');
          } else {
            swal("Erro", "Erro ao baixar PDF.", "error");
          }
        },
        error => {
          this.carregandoTabela = false;
          this.func.showErro(error.json());
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/area-cliente/meus-laudos-pdf/meus-laudos-pdf.component.ts